import type { Replay } from "@/mocks/replays";
import ReplayCard from "@/components/base/ReplayCard";
import SectionHeader from "@/components/base/SectionHeader";

interface ReplaySectionProps {
  replays: Replay[];
}

export default function ReplaySection({ replays }: ReplaySectionProps) {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto">
        <SectionHeader
          title="精选回放"
          subtitle="错过直播也不怕，全场回放与精彩集锦随时观看"
          moreTo="/replay"
          moreLabel="全部回放"
          icon={<i className="ri-play-circle-line text-lg" />}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {replays.map((r) => (
            <ReplayCard key={r.id} replay={r} />
          ))}
        </div>
      </div>
    </section>
  );
}